exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kayenta-overview-toggle {\n  height: 30px;\n  line-height: 30px;\n  cursor: pointer;\n  padding-right: 0 10px;\n}\n.kayenta-overview-toggle p {\n  height: 100%;\n  text-transform: uppercase;\n  margin: 0 10px;\n}\n.kayenta-overview-toggle span {\n  margin-bottom: 4px;\n}\n", ""]);

